import { AxiosInterceptor } from "api/core/consts";

export const claimApi = {
  searchAllClaim: (paging, body) => AxiosInterceptor.post('customerClaim/search' + paging, body),
  createClaim: (body) => AxiosInterceptor.post('customerClaim', body),
  updateClaim: (claimId, body) => AxiosInterceptor.put('customerClaim/' + claimId, body),
  deleteClaim: (claimId) => AxiosInterceptor.delete('customerClaim/' + claimId),
};
